/**
 * #telemetry.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { messageTypeRegistry } from "../../../../../typeRegistry.js";
function createBaseWebViewTelemetryEffect() {
    return { event: undefined, click: undefined, loaded: undefined, metrics: undefined };
}
export const WebViewTelemetryEffect = {
    $type: "devvit.ui.effects.web_view.v1alpha.WebViewTelemetryEffect",
    encode(message, writer = _m0.Writer.create()) {
        if (message.event !== undefined) {
            writer.uint32(10).string(message.event);
        }
        if (message.click !== undefined) {
            WebViewTelemetryClickEffect.encode(message.click, writer.uint32(18).fork()).ldelim();
        }
        if (message.loaded !== undefined) {
            WebViewTelemetryLoadedEffect.encode(message.loaded, writer.uint32(26).fork()).ldelim();
        }
        if (message.metrics !== undefined) {
            WebViewTelemetryMetricsEffect.encode(message.metrics, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebViewTelemetryEffect();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.event = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.click = WebViewTelemetryClickEffect.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.loaded = WebViewTelemetryLoadedEffect.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.metrics = WebViewTelemetryMetricsEffect.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            event: isSet(object.event) ? globalThis.String(object.event) : undefined,
            click: isSet(object.click) ? WebViewTelemetryClickEffect.fromJSON(object.click) : undefined,
            loaded: isSet(object.loaded) ? WebViewTelemetryLoadedEffect.fromJSON(object.loaded) : undefined,
            metrics: isSet(object.metrics) ? WebViewTelemetryMetricsEffect.fromJSON(object.metrics) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.event !== undefined) {
            obj.event = message.event;
        }
        if (message.click !== undefined) {
            obj.click = WebViewTelemetryClickEffect.toJSON(message.click);
        }
        if (message.loaded !== undefined) {
            obj.loaded = WebViewTelemetryLoadedEffect.toJSON(message.loaded);
        }
        if (message.metrics !== undefined) {
            obj.metrics = WebViewTelemetryMetricsEffect.toJSON(message.metrics);
        }
        return obj;
    },
    create(base) {
        return WebViewTelemetryEffect.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWebViewTelemetryEffect();
        message.event = object.event ?? undefined;
        message.click = (object.click !== undefined && object.click !== null)
            ? WebViewTelemetryClickEffect.fromPartial(object.click)
            : undefined;
        message.loaded = (object.loaded !== undefined && object.loaded !== null)
            ? WebViewTelemetryLoadedEffect.fromPartial(object.loaded)
            : undefined;
        message.metrics = (object.metrics !== undefined && object.metrics !== null)
            ? WebViewTelemetryMetricsEffect.fromPartial(object.metrics)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(WebViewTelemetryEffect.$type, WebViewTelemetryEffect);
function createBaseWebViewTelemetryClickEffect() {
    return { event: "", definition: "", elemTrackId: undefined };
}
export const WebViewTelemetryClickEffect = {
    $type: "devvit.ui.effects.web_view.v1alpha.WebViewTelemetryClickEffect",
    encode(message, writer = _m0.Writer.create()) {
        if (message.event !== "") {
            writer.uint32(10).string(message.event);
        }
        if (message.definition !== "") {
            writer.uint32(18).string(message.definition);
        }
        if (message.elemTrackId !== undefined) {
            writer.uint32(26).string(message.elemTrackId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebViewTelemetryClickEffect();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.event = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.definition = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.elemTrackId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            event: isSet(object.event) ? globalThis.String(object.event) : "",
            definition: isSet(object.definition) ? globalThis.String(object.definition) : "",
            elemTrackId: isSet(object.elemTrackId) ? globalThis.String(object.elemTrackId) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.event !== "") {
            obj.event = message.event;
        }
        if (message.definition !== "") {
            obj.definition = message.definition;
        }
        if (message.elemTrackId !== undefined) {
            obj.elemTrackId = message.elemTrackId;
        }
        return obj;
    },
    create(base) {
        return WebViewTelemetryClickEffect.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWebViewTelemetryClickEffect();
        message.event = object.event ?? "";
        message.definition = object.definition ?? "";
        message.elemTrackId = object.elemTrackId ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(WebViewTelemetryClickEffect.$type, WebViewTelemetryClickEffect);
function createBaseWebViewTelemetryLoadedEffect() {
    return { event: "", timeStart: 0, timeEnd: 0, duration: 0 };
}
export const WebViewTelemetryLoadedEffect = {
    $type: "devvit.ui.effects.web_view.v1alpha.WebViewTelemetryLoadedEffect",
    encode(message, writer = _m0.Writer.create()) {
        if (message.event !== "") {
            writer.uint32(10).string(message.event);
        }
        if (message.timeStart !== 0) {
            writer.uint32(17).double(message.timeStart);
        }
        if (message.timeEnd !== 0) {
            writer.uint32(25).double(message.timeEnd);
        }
        if (message.duration !== 0) {
            writer.uint32(33).double(message.duration);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebViewTelemetryLoadedEffect();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.event = reader.string();
                    continue;
                case 2:
                    if (tag !== 17) {
                        break;
                    }
                    message.timeStart = reader.double();
                    continue;
                case 3:
                    if (tag !== 25) {
                        break;
                    }
                    message.timeEnd = reader.double();
                    continue;
                case 4:
                    if (tag !== 33) {
                        break;
                    }
                    message.duration = reader.double();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            event: isSet(object.event) ? globalThis.String(object.event) : "",
            timeStart: isSet(object.timeStart) ? globalThis.Number(object.timeStart) : 0,
            timeEnd: isSet(object.timeEnd) ? globalThis.Number(object.timeEnd) : 0,
            duration: isSet(object.duration) ? globalThis.Number(object.duration) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.event !== "") {
            obj.event = message.event;
        }
        if (message.timeStart !== 0) {
            obj.timeStart = message.timeStart;
        }
        if (message.timeEnd !== 0) {
            obj.timeEnd = message.timeEnd;
        }
        if (message.duration !== 0) {
            obj.duration = message.duration;
        }
        return obj;
    },
    create(base) {
        return WebViewTelemetryLoadedEffect.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWebViewTelemetryLoadedEffect();
        message.event = object.event ?? "";
        message.timeStart = object.timeStart ?? 0;
        message.timeEnd = object.timeEnd ?? 0;
        message.duration = object.duration ?? 0;
        return message;
    },
};
messageTypeRegistry.set(WebViewTelemetryLoadedEffect.$type, WebViewTelemetryLoadedEffect);
function createBaseWebViewTelemetryMetric() {
    return { spanName: "", timeStart: 0, timeEnd: 0 };
}
export const WebViewTelemetryMetric = {
    $type: "devvit.ui.effects.web_view.v1alpha.WebViewTelemetryMetric",
    encode(message, writer = _m0.Writer.create()) {
        if (message.spanName !== "") {
            writer.uint32(10).string(message.spanName);
        }
        if (message.timeStart !== 0) {
            writer.uint32(17).double(message.timeStart);
        }
        if (message.timeEnd !== 0) {
            writer.uint32(25).double(message.timeEnd);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebViewTelemetryMetric();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.spanName = reader.string();
                    continue;
                case 2:
                    if (tag !== 17) {
                        break;
                    }
                    message.timeStart = reader.double();
                    continue;
                case 3:
                    if (tag !== 25) {
                        break;
                    }
                    message.timeEnd = reader.double();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            spanName: isSet(object.spanName) ? globalThis.String(object.spanName) : "",
            timeStart: isSet(object.timeStart) ? globalThis.Number(object.timeStart) : 0,
            timeEnd: isSet(object.timeEnd) ? globalThis.Number(object.timeEnd) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.spanName !== "") {
            obj.spanName = message.spanName;
        }
        if (message.timeStart !== 0) {
            obj.timeStart = message.timeStart;
        }
        if (message.timeEnd !== 0) {
            obj.timeEnd = message.timeEnd;
        }
        return obj;
    },
    create(base) {
        return WebViewTelemetryMetric.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWebViewTelemetryMetric();
        message.spanName = object.spanName ?? "";
        message.timeStart = object.timeStart ?? 0;
        message.timeEnd = object.timeEnd ?? 0;
        return message;
    },
};
messageTypeRegistry.set(WebViewTelemetryMetric.$type, WebViewTelemetryMetric);
function createBaseWebViewTelemetryMetricsEffect() {
    return { metrics: [] };
}
export const WebViewTelemetryMetricsEffect = {
    $type: "devvit.ui.effects.web_view.v1alpha.WebViewTelemetryMetricsEffect",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.metrics) {
            WebViewTelemetryMetric.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebViewTelemetryMetricsEffect();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.metrics.push(WebViewTelemetryMetric.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            metrics: globalThis.Array.isArray(object?.metrics)
                ? object.metrics.map((e) => WebViewTelemetryMetric.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.metrics?.length) {
            obj.metrics = message.metrics.map((e) => WebViewTelemetryMetric.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return WebViewTelemetryMetricsEffect.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWebViewTelemetryMetricsEffect();
        message.metrics = object.metrics?.map((e) => WebViewTelemetryMetric.fromPartial(e)) || [];
        return message;
    },
};
messageTypeRegistry.set(WebViewTelemetryMetricsEffect.$type, WebViewTelemetryMetricsEffect);
function isSet(value) {
    return value !== null && value !== undefined;
}
